import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, stopPropagation } from '@nu-art/thunderstorm-frontend/index';
import { avatarMode } from '@app/advisor-shared';
import { exists, scrub } from '@nu-art/ts-common';
import { ModuleFE_AdvisorSession, ModuleFE_EMInterface } from '@app/advisor-frontend';
import './Renderer_Score.scss';
import { Loader_Score } from './Loader_Score.js';
export class Renderer_Score extends ComponentSync {
    //######################### Life Cycle #########################
    __onRuntimeFindingsUpdated = (...params) => this.forceUpdate();
    __onInvalidRuntimeFindingsUpdated = (...params) => this.forceUpdate();
    deriveStateFromProps(nextProps, state) {
        state.scoreData = nextProps.scoreData;
        const userType = ModuleFE_AdvisorSession.getUserType();
        //The score is disabled if we are post disposition or if we are in nurse view or avatar mode
        state.disabled = ModuleFE_EMInterface.isPostDisposition() || userType === 'nurse' || userType === avatarMode;
        state.ignoreClick = !!nextProps.ignoreClick;
        return state;
    }
    //######################### Logic #########################
    onScoreClick = async (e) => {
        stopPropagation(e);
        if (this.state.disabled || this.state.ignoreClick)
            return;
        return this.state.scoreData.openScoreEdit();
    };
    //######################### Render #########################
    render() {
        const data = this.state.scoreData;
        const style = scrub({ '--severity-color': data.getSeverity()?.color, });
        return _jsxs(Button, { style: style, variant: 'score', onClick: this.onScoreClick, className: 'protocol__score', disabled: this.state.disabled, loader: Loader_Score, children: [this.state.scoreData.getLabel(), _jsx("div", { className: 'protocol__score__value', children: this.render_Value() })] });
    }
    render_Value = () => {
        const value = this.state.scoreData.getValue();
        if (exists(value))
            return String(value);
        const partialValue = this.state.scoreData.getPartialValue();
        if (exists(partialValue))
            return `≥${partialValue}`;
        return '-';
    };
}
//# sourceMappingURL=Renderer_Score.js.map